import React from 'react';
import { Modal } from 'react-bootstrap';

import './VideoModal.css';

export default class VideoModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            show: props.show
        };
    }

    close() {
        this.setState({show: false});
    }

    render() {
        return (
            <Modal className="modal-video" bsSize="large" show={this.state.show} onHide={this.close.bind(this)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe className="embed-responsive-item" src={"https://player.vimeo.com/video/"+ this.props.videoId +"?autoplay=1"} allowFullScreen></iframe>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/VideoModal.js